import glamorous from 'glamorous';

const PlayerSelectionIcon = glamorous.span(
  ({ theme }) => ({
    color: theme.color.warning,
    display: 'inline-block',
    transform: 'rotate(90deg)',
  }),
  'ion-stats-bars',
);

export default PlayerSelectionIcon;
